<template>
  <div v-if="visible">
    <div class="popup_wrap search_protocol">
      <div class="popup_title">
        <p><span id="node_title">프로토콜 검색
        </span></p>
        <a>
          <div id="popup_close" class="btn_close" title="Close" @click="close">
            <div class="btn_close_box"><span></span><span></span></div>
          </div>
        </a>
      </div><!-- //popup_title -->
      <div class="popup_content">
        <div class="tbl_wrap">
          <div class="search_form_wrap">
            <div class="search-option">
              <ul class="search_form_list">
                <li style="width: 10%;">
                  <FieldSelector
                          :options="'protocol'"
                          @change="(value)=>selectSearchFiled=value.value"/>
                </li>
                <li style="width: 14%;">
                  <SearchTargetSelector
                          :options="'protocol'"
                          @change="(value)=>selectSearchTarget=value.value"/>
                </li>
                <li style="width: 76%;">
                  <div class="inpt_sch">
                    <input type="text" class="form_control" @keydown="inputEnter"
                           @input="setSearchInputData"
                           :value="searchInputData" placeholder="검색어를 입력하세요."/>
                    <button type="button" @click="pageNo=1; totalPage=0; search();"></button>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <table class="tbl_style2">
            <colgroup>
              <col style="width: 17%;">
              <col style="width: 20%;">
              <col style="width: 50%;">
              <col style="width: 10%;">
            </colgroup>
            <thead>
            <tr style="cursor: pointer;">
              <th>생성/수정일
                <button class="sorting"></button>
              </th>
              <th>구분</th>
              <th>프로토콜명
                <button class="sorting"></button>
              </th>
              <th>작성자</th>
            </tr>
            </thead>
          </table>
          <div class="tbl_wrap custom_overflow_wrap">
            <table class="tbl_style2">
              <colgroup>
                <col style="width: 17%;">
                <col style="width: 20%;">
                <col style="width: 50%;">
                <col style="width: 9%;">
              </colgroup>
              <tbody>
              <tr v-for="(item, index) in processList"
                  @click="selectProcess(index, $event)"
                  :data-list-index="index"
                  :class="{selected: (index === selectedProcessIndex)}"
                  style="cursor: pointer;"
              >
                <td>
                  <span>{{(item.createdDate || item.createDate) | timeFilter}}</span><br>
                  <span>{{(item.updatedDate || '') | timeFilter}}</span>
                </td>
                <td><span class="ellipsis"
                          v-html="`${item.protocolType} (${item.equipment})`"></span>
                </td>
                <td><span class="ellipsis"
                          v-html="item.protocolName"></span>
                </td>
                <td>{{item.userName ? item.userName : item.user.userName}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <Pagination ref="resultsCount" :pageCnt="pageNo" :pageTotalCnt="totalPage" :size="9"
                    @click="selectPage" extraClass="paging_ui"></Pagination>
      </div>
      <div class="popup_footer">
        <a class="btn_type2" @click="callProtocolDetail">미리보기</a>
        <a class="btn_type1" @click="connectProtocol">연결</a>
        <a class="btn_type3" @click="close">닫기</a>
      </div>
    </div>
    <div class="mask_wrap" style="display:block;"></div>
    <Loading :visible="loading" type="fixed"/>
  </div>
</template>

<script>
  import Loading from '@common/loading.vue';
  import {createNamespacedHelpers} from 'vuex';
  import Pagination from '@common/NewPagination'
  import FieldSelector from '@common/selects/FieldSelector'
  import SearchTargetSelector from '@common/selects/TargetSelector'

  const Hub = createNamespacedHelpers('Hub');
  const ProcessEditor = createNamespacedHelpers('ProcessEditor');

  export default {
    components: {
      Loading,
      Pagination,
      FieldSelector,
      SearchTargetSelector,
    },
    data() {
      return {
        loading: null,
        visible: false,
        pageNo: 1,
        totalPage: 0,
        selected: null,
        searchInputData: '',
        processList: [],
        selectedProcessIndex: null,
        selectSearchFiled: 0,
        selectSearchTarget: 'name',
        processId: null,
        keyOfProtocol: null,
        maxConnectCount: 1,
      }
    },
    computed: {
      ...Hub.mapGetters(
          [
            'getSearchProtocolObj'
          ]),
    },
    watch: {
      getSearchProtocolObj: {
        deep: true,
        async handler(value) {
          if (value.searchProtocolPopFlag === true && typeof value.connectNodeInfo == 'object') {
            this.show();
          } else if (value.searchProtocolPopFlag === false) {
            this.visible = false;
          }
        }
      },
    },
    filters: {
      timeFilter(time) {
        if (time) time = time.replace('T', ' ');
        else time = '';
        return time
      }
    },
    async mounted() {
    },
    methods: {
      ...Hub.mapMutations(
          [
            'setSearchProtocolObj'
            , 'setProtocolDetailObj'
            , 'setConnectProtocolObj'
          ]
      ),
      inputEnter(event) {
        if (event.code === 'Enter' || event.keyCode === 13) {
          this.pageNo = 1;
          this.totalPage = 0;
          this.search();
        }
      },
      setSearchInputData(e) {
        if (!(e.code === 'Enter' || e.keyCode === 13)) {
          this.searchInputData = e.target.value;
        }
      },
      async selectPage(index) {
        this.pageNo = index;
        this.selected = null;
        await this.search();
        return
      },
      show() {
        this.visible = true;
        this.processId = this.$route.query.processId;
        this.keyOfProtocol = this.getSearchProtocolObj.connectNodeInfo.key
        this.search();
      },
      resetData() {
        this.loading = null;
        this.visible = false;
        this.pageNo = 1;
        this.totalPage = 0;
        this.selected = null;
        this.searchInputData = '';
        this.processList = [];
        this.selectedProcessIndex = null;
        this.selectSearchFiled = 0;
        this.selectSearchTarget = 'name';
        this.keyOfProtocol = null;
        this.processId = null;
        this.maxConnectCount = 1;
      },
      async close() {
        this.resetData();
        await this.openConnectProtocolPop();
        this.setSearchProtocolObj({
          openFlag: false,
          dataObj: {}
        });
      },
      selectProcess(index, event) {
        this.selectedProcessIndex = index;
        this.selected = this.processList[index];
      },
      async openConnectProtocolPop(){
        this.setConnectProtocolObj({
          openFlag: true,
          dataObj: {
            ...this.getSearchProtocolObj.connectNodeInfo
          }
        });
      },
      async search() {
        if (!this.visible) return;
        this.loading = true
        try {
          let searchProperty = {
            query: this.searchInputData,
            targetField: this.selectSearchTarget,
            pageNo: this.pageNo,
            perPage: this.pageShowCnt,
            searchMaterial: "",
            searchPurpose: "",
            searchEquipment: "",
          }
          searchProperty.fieldId = this.selectSearchFiled === 0 ? null : this.selectSearchFiled;
          searchProperty.isMyData = 0;
          searchProperty.protocolType = 'FULL';
          const searchType = searchProperty;

          let response = await this.$wApi.protocol.search(searchType);

          this.processList = response.content;
          this.totalPage = response.totalPages;
          this.loading = false
        } catch (error) {
          this.loading = false
        }
      },
      async checkCount(){
        this.loading = true;
        const connectedProtocols = await this.$wApi.process.getProtocols(null, this.processId);
        this.loading = false;
        if(connectedProtocols && connectedProtocols.length > 0) {
          return connectedProtocols.filter(protocol => protocol.innerKeyOfProtocol == this.keyOfProtocol).length;
        }else{
          return 0;
        }
      },
      async connectProtocol() {
        if (!this.selected) {
          await window.alert(`프로토콜을 선택해 주세요`);
          return;
        }
        if(!this.keyOfProtocol){
          await window.alert(`연결 중 오류가 발생했습니다.<br>잠시 후 다시 시도해 주세요`);
          return;          
        }
        const protocolConnectedCount=await this.checkCount();
        if(protocolConnectedCount >= this.maxConnectCount) {
          await window.alert(`현재 프로토콜 연결은 노드당 ${this.maxConnectCount}개만 가능합니다.`);
          this.close();
          return;
        }
        
        this.loading = true;
        let response = await this.$wApi.protocol.connect({
          protocolId: this.selected.protocolId, // 연결하고자 하는 원본 only_protocol의 id
          processId: this.processId, // 연결하고자하는 process ID
          keyOfProtocol: this.keyOfProtocol, // 연결하고자하는 process의 keyOfProtocol
          connectFlag: 1, // 연결
        });
        if (response.originProtocolId) {
          this.loading = false;
          await window.alert('연결이 완료되었습니다.');
          await this.close();
        }
        if (response == null || response?.error){
          this.loading = false;
          await window.alert(response.message);
        }
      },
      async callProtocolDetail() {
        if (!this.selected) {
          window.alert(`프로토콜을 선택해 주세요`);
          return;
        }
        let protocolDetailData = {};
        protocolDetailData.protocolId = this.selected.protocolId;
        protocolDetailData.processId = this.processId;
        protocolDetailData.isPublish = false;
        this.setProtocolDetailObj({
          openFlag: true,
          dataObj: protocolDetailData,
        });
      },
    }
  }
</script>

<style lang="scss">
  @import "@/style/new/css/cyl.common.css";

  .search_protocol {
    display: block;
    position: fixed;
    width: 1200px;
    height: 85%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
    box-shadow: 5px 5px 20px 0px rgba(0, 0, 0, 0.2);
  }

  @media screen and (max-width: 950px) {
    .search_protocol {
      width: 95%;
    }
    .custom_overflow_wrap {
      height: 100px;
    }
  }

</style>
